<template>
	<div class="contact" :style="fundo">
		<div class="container">
			<h3>Entre em contato conosco</h3>
			<div class="contact-row">
				<div class="contact-details">
					<div>
						<p :style="corPrimaria">Ficou com alguma dúvida? Entre em contato com a nossa equipe de suporte.</p>
						<div v-if="parceiro && parceiroConfig.sessoes.contact.campos.whatsapp && parceiroConfig.sessoes.contact.campos.whatsapp.length > 0" class="contact-social mt-5 pt-5" :style="corPrimaria">
							<i class="fab fa-whatsapp" />
							<h6>{{ parceiroConfig.sessoes.contact.campos.whatsapp }}</h6>
						</div>
						<div v-else-if="!parceiro" class="contact-social mt-5 pt-5" :style="corPrimaria">
							<i class="fab fa-whatsapp" />
							<h6>(42) 99983-2385</h6>
						</div>

						<div v-if="parceiro && parceiroConfig.sessoes.contact.campos.phone && parceiroConfig.sessoes.contact.campos.phone.length > 0" class="contact-social" :style="corPrimaria">
							<i class="fas fa-phone" :style="corPrimaria" />
							<h6>{{ parceiroConfig.sessoes.contact.campos.phone }}</h6>
						</div>
						<div v-else-if="!parceiro" class="contact-social" :style="corPrimaria">
							<i class="fas fa-phone" />
							<h6>(41) 3222-5213</h6>
						</div>

						<div v-if="parceiro && parceiroConfig.sessoes.contact.campos.email && parceiroConfig.sessoes.contact.campos.email.length > 0" class="contact-social" :style="corPrimaria">
							<i class="fas fa-envelope" :style="corPrimaria" />
							<h6>{{ parceiroConfig.sessoes.contact.campos.email }}</h6>
						</div>
						<div v-else-if="!parceiro" class="contact-social" :style="corPrimaria">
							<i class="fas fa-envelope" />
							<h6>contato@acerteaqui.com.br</h6>
						</div>

						<div v-if="parceiro && parceiroConfig.sessoes.contact.campos.address && parceiroConfig.sessoes.contact.campos.address.length > 0" class="contact-social" :style="corPrimaria">
							<i class="fas fa-map-marker-alt" :style="corPrimaria" />
							<h6>{{ parceiroConfig.sessoes.contact.campos.address }}</h6>
						</div>
						<div v-else-if="!parceiro" class="contact-social">
							<i class="fas fa-map-marker-alt" />
							<h6>Rua Nunes Machado, 79 - loja 10 - Hyde Park – Centro – Curitiba – PR - CEP: 80.250-000</h6>
						</div>

						<div class="social-circle-row">
							<div class="social-circle" v-if="parceiro && parceiroConfig.sessoes.contact.campos.url_facebook && parceiroConfig.sessoes.contact.campos.url_facebook.length > 0" :style="corPrimaria" @click="goToSite(parceiroConfig.sessoes.contact.campos.url_facebook, 29, 'Página inicial')">
								<i class="fab fa-facebook-f" />
							</div>
							<div class="social-circle" v-else-if="!parceiro" :style="corPrimaria" @click="goToSite('https://pt-br.facebook.com/aquicob/', 29, 'Página inicial')">
								<i class="fab fa-facebook-f" />
							</div>

							<div class="social-circle" v-if="parceiro && parceiroConfig.sessoes.contact.campos.url_instagram && parceiroConfig.sessoes.contact.campos.url_instagram.length > 0" :style="corPrimaria" @click="goToSite(parceiroConfig.sessoes.contact.campos.url_instagram, 30, 'Página inicial')">
								<i class="fab fa-instagram" />
							</div>
							<div class="social-circle" v-else-if="!parceiro" :style="corPrimaria" @click="goToSite('https://www.instagram.com/aquicob/', 30, 'Página inicial')">
								<i class="fab fa-instagram" />
							</div>

							<div class="social-circle" v-if="parceiro && parceiroConfig.sessoes.contact.campos.whatsapp && parceiroConfig.sessoes.contact.campos.whatsapp.length > 0" @click="goToSite('https://api.whatsapp.com/send?phone=55' + removeMaskCharacters(parceiroConfig.sessoes.contact.campos.whatsapp) + '&text=%23Olá estou vindo do portal ' + parceiro.toUpperCase(), 15, 'Página inicial')">
								<i class="fab fa-whatsapp" />
							</div>
						</div>
					</div>
				</div>
				<div class="contact-img">
					<div class="form">
						<input v-model="name" type="text" placeholder="Nome" />
						<input v-model="email" type="text" placeholder="E-mail" />
						<the-mask v-model="identification" placeholder="CPF/CNPJ" pattern="[0-9]*" inputmode="numeric" :mask="['###.###.###-##', '##.###.###/####-##']" />
						<textarea v-model="text" placeholder="Como podemos ajudar?" />
						<button class="form-button" :style="corPrimaria" @click="sendMessage">Enviar mensagem</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import { mapMutations, mapState, mapActions } from "vuex";
import axios from "axios";
import globalMethods from "@/mixins/globalMethods";
export default {
	name: "LandPageContact",
	components: { TheMask },
	mixins: [globalMethods],
	data() {
		return {
			name: "",
			email: "",
			identification: "",
			text: ""
		};
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			corPrimaria: (state) => state.corPrimaria
		}),
		fundo: function () {
			return {
				"--fundoFull": "url(" + require(`../../../assets/images/support.svg`) + ")",
				"--fundo450": "url(" + require(`../../../assets/images/support450.png`) + ")"
			};
		}
	},
	methods: {
		...mapActions(["action_salvar_etapa"]),
		...mapMutations(["CHANGE_MESSAGE_MODAL", "CHANGE_MESSAGE_SNACKBAR"]),
		goToSite(url, esn_fk_ets_codigo, observacao = "") {
			this.action_salvar_etapa({
				cpfCnpj: this.removeMaskCharacters(this.identification),
				esn_fk_ets_codigo: esn_fk_ets_codigo,
				emp_codigo: this.parceiroConfig.emp_codigo,
				motivo_agendamento: observacao
			}).then((response) => {});
			let win = window.open(url, "_blank");
			win.focus();
		},
		sendMessage() {
			if (!this.name || this.name.length < 3 || this.name.length > 20 || this.name.toString().split(".").join("").length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Nome é obrigatório!",
					message: `Por favor, digite o seu nome completo`,
					styleMessage: "danger"
				});
			} else if (/.+@.+\..+/.test(this.email) === false) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "E-mail é obrigatório!",
					message: `Por favor, digite um e-mail válido`,
					styleMessage: "danger"
				});
			} else if (!this.validIdentification(this.identification)) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "CPF/CNPJ é obrigatório!",
					message: `Por favor, digite um CPF/CNPJ válido`,
					styleMessage: "danger"
				});
			} else if (this.text.length < 10 || this.text.length > 300) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Mensagem é obrigatória!",
					message: `Por favor, digite uma mensagem`,
					styleMessage: "danger"
				});
			} else {
				let obj = {
					nome: this.name,
					email: this.email,
					documento: this.identification,
					descricao: this.text
				};
				axios.post("https://apinew.acerteaqui.com/api/email_contato", obj)
					.then(() => {
						this.name = "";
						this.email = "";
						this.identification = "";
						this.text = "";
						this.CHANGE_MESSAGE_SNACKBAR("E-mail enviado com sucesso!");
						setTimeout(() => this.CHANGE_MESSAGE_SNACKBAR(""), 5000);
					})
					.catch((error) => {
						if (error.response) {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Atenção!",
								message: `Ocorreu um erro ao enviar o e-mail. Tente novamente mais tarde`,
								styleMessage: "danger"
							});
						}
					});
			}
		},
		validIdentification(ident) {
			if (ident.length == 11) {
				var Soma;
				var Resto;
				Soma = 0;
				var strCPF = ident;
				if (strCPF == "00000000000") return false;

				for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
				Resto = (Soma * 10) % 11;

				if (Resto == 10 || Resto == 11) Resto = 0;
				if (Resto != parseInt(strCPF.substring(9, 10))) return false;

				Soma = 0;
				for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
				Resto = (Soma * 10) % 11;

				if (Resto == 10 || Resto == 11) Resto = 0;
				if (Resto != parseInt(strCPF.substring(10, 11))) return false;

				return true;
			} else if (ident.length == 14) {
				var c = ident;
				var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

				if ((c = c.replace(/[^\d]/g, "")).length != 14) return false;

				if (/0{14}/.test(c)) return false;

				for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
				if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

				for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
				if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;
				return true;
			} else {
				return false;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.contact {
	padding: 60px 0;
	width: 100%;
	/* Set a specific height */
	min-height: 500px;

	/* Create the parallax scrolling effect */
	background-image: var(--fundoFull);
	background-attachment: fixed;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;

	@media only screen and (max-width: 1290px) {
		background-image: var(--fundo450);
		background-size: 100% 100%;
		background-attachment: initial;
	}
	@media only screen and (max-width: 450px) {
		background-image: var(--fundo450);
		background-size: 100% 100%;
		background-attachment: initial;
	}

	h3 {
		text-align: left;
		font-size: 32px;
		font-family: "Montserrat-Bold";
		color: var(--darkColor);
		line-height: 48px;
		margin-bottom: 30px;
		@media only screen and (max-width: 1290px) {
			text-align: center;
		}
	}

	p {
		color: var(--darkColor);
		font-family: Cabin;
		font-size: 20px;
		@media only screen and (max-width: 1290px) {
			margin-top: 30px;
		}
	}
}

.contact-row {
	display: flex;
	flex-direction: row;
	@media only screen and (max-width: 1290px) {
		flex-direction: column-reverse;
		align-items: center;
		justify-content: center;
	}
}

.contact-details {
	width: 450px;
	box-sizing: border-box;
	@media only screen and (max-width: 1290px) {
		width: 500px;
		padding: 0 30px;
	}
	@media only screen and (max-width: 766px) {
		width: 85vw;
		padding: 0;
	}
}

.contact-social {
	display: flex;
	align-items: center;
	margin: 30px 0;
	transition: all 0.2s ease-in-out;
	border: 2px solid transparent;
	border-radius: 27px;
	padding: 10px 30px;
	&:hover {
		background-color: var(--darkColor);
		border-color: var(--whiteColor);
		transition: all 0.2s ease-in-out;
		cursor: pointer;
		i {
			color: var(--whiteColor);
			transition: all 0.2s ease-in-out;
			cursor: pointer;
		}
		h6 {
			color: var(--whiteColor);
			transition: all 0.2s ease-in-out;
			cursor: pointer;
		}
	}
	i {
		font-size: 24px;
		color: var(--color);
		margin-right: 15px;
		transition: all 0.2s ease-in-out;
	}
}

.contact-social:hover .contact-social h6 {
	font-size: 16px;
	font-family: Cabin;
	color: var(--darkColor);
	margin: 0;
}

.contact-img {
	display: flex;
	flex: 1;
	justify-content: flex-end;
	.form {
		text-align: center;
		background: var(--whiteColor);
		width: 500px;
		height: 460px;
		display: flex;
		border-radius: 7px;
		box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.07);
		padding: 15px 30px;
		flex-direction: column;
		box-sizing: border-box;
		@media only screen and (max-width: 766px) {
			width: 85vw;
			padding: 10px 20px;
		}
		input {
			color: #595959;
			font-family: "Montserrat-Bold";
			height: 50px;
			border: 0;
			border-bottom: 1px solid var(--secondaryColor);
			margin: 15px 0;
			font-size: 20px;
			color: var(--secondaryColor);
			&::placeholder {
				color: #595959;
				font-family: "Montserrat-Bold";
				font-size: 18px;
			}
		}
		textarea {
			color: #595959;
			font-family: "Montserrat-Bold";
			font-size: 20px;
			height: 100px;
			border: 0;
			border-bottom: 1px solid var(--secondaryColor);
			margin: 15px 0;
			color: var(--secondaryColor);
			&::placeholder {
				color: #595959;
				font-family: "Montserrat-Bold";
				font-size: 18px;
			}
		}
		button {
			width: 100%;
			height: 50px;
			border-radius: 25px;
			background: var(--color);
			color: var(--whiteColor);
			border: 0;
			font-size: 18px;
			font-family: Cabin;
			cursor: pointer;
			transition: all 0.2s ease-in-out;
			&:hover {
				background-color: var(--hovercolor);
				border-color: var(--whiteColor);
				transition: all 0.2s ease-in-out;
				cursor: pointer;
			}
		}
	}
}
.social-circle-row {
	display: flex;
	align-items: center;
	margin-top: 50px;
	padding: 0 28px;
	@media only screen and (max-width: 1290px) {
		justify-content: space-around;
		margin-top: 50px;
	}
}

.social-circle {
	cursor: pointer;
	width: 60px;
	height: 60px;
	background: var(--primaryColor);
	border-radius: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--whiteColor);
	margin-right: 30px;
	transition: all 0.2s ease-in-out;
	@media only screen and (max-width: 1290px) {
		margin-right: 0;
	}
	&:hover {
		background-color: var(--darkColor);
		transition: all 0.2s ease-in-out;
		cursor: pointer;
	}
	i {
		font-size: 20px;
	}
}

@media only screen and (min-width: 1400px) {
	.contact-details {
		display: flex;
		flex: 1;
		justify-content: flex-end;
		padding-right: 50px;
	}
	.contact-img {
		padding-left: 50px;
		flex: 1;
		justify-content: flex-start;
	}

	.contact h3 {
		text-align: center;
	}
}
</style>
